/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MailboxTemplateKind = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;
export type MailboxTemplateKind = typeof MailboxTemplateKind[keyof typeof MailboxTemplateKind];


export function instanceOfMailboxTemplateKind(value: any): boolean {
    for (const key in MailboxTemplateKind) {
        if (Object.prototype.hasOwnProperty.call(MailboxTemplateKind, key)) {
            if (MailboxTemplateKind[key as keyof typeof MailboxTemplateKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MailboxTemplateKindFromJSON(json: any): MailboxTemplateKind {
    return MailboxTemplateKindFromJSONTyped(json, false);
}

export function MailboxTemplateKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxTemplateKind {
    return json as MailboxTemplateKind;
}

export function MailboxTemplateKindToJSON(value?: MailboxTemplateKind | null): any {
    return value as any;
}

export function MailboxTemplateKindToJSONTyped(value: any, ignoreDiscriminator: boolean): MailboxTemplateKind {
    return value as MailboxTemplateKind;
}

